import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/menu.png'


const _hoisted_1 = { class: "pull-left info" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSideBar',
  setup(__props) {

const { t } = useI18n();
const store = useStore();

const menuList = computed(() => {
	return [
		{
			header: 'Menu List',
		},
		{
			name: t('route.P_RootManagent'),
			icon: { text: 'Person', class: 'material-symbols-outlined' },
			children: [
				{
					name: t('route.C_AdminList'),
					href: '/adminlist',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_Notice'),
					href: '/notice',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_ChainInfo'),
					href: '/chaininfo',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_TokenInfo'),
					href: '/tokeninfo',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_Memo'),
					href: '/memo',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_UserList'),
					href: '/userlist',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
			],
		},
		// {
		//   name: t("route.P_GroupManagent"),
		//   icon: { text: "Person", class: "material-symbols-outlined" },
		//   children: [
		//     {
		//       name: t("route.C_Group_UserList"),
		//       href: "/group_user_list",
		//       icon: { text: "Circle", class: "material-symbols-outlined" },
		//     },
		//   ],
		// },
		// {
		//   name: t("route.P_BuyCoins"),
		//   icon: { text: "Person", class: "material-symbols-outlined" },
		//   children: [
		//     {
		//       name: t("route.C_UserTokensList"),
		//       href: "/usertokens_list",
		//       icon: { text: "Circle", class: "material-symbols-outlined" },
		//     },
		//     {
		//       name: t("route.C_WithdrwalHistory"),
		//       href: "/withdrawal_history",
		//       icon: { text: "Circle", class: "material-symbols-outlined" },
		//     },
		//   ],
		// },
		{
			name: t('route.P_AppManagent'),
			icon: { text: 'Person', class: 'material-symbols-outlined' },
			children: [
				{
					name: t('route.C_Banner'),
					href: '/banner',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_Category'),
					href: '/category',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},

				{
					name: t('route.C_NftInfo'),
					href: '/nft_info',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_UserPoint'),
					href: '/user_point',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_UserNftList'),
					href: '/user_nft',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				// {
				//   name: t("route.C_UserGameTokenList"),
				//   href: "/user_gametoken",
				//   icon: { text: "Circle", class: "material-symbols-outlined" },
				// },
				{
					name: t('route.C_UserRewardsList'),
					href: '/user_reward',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_MarketCategory'),
					href: '/market_category',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_MarketProductList'),
					href: '/market_product',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_MarketOrderList'),
					href: '/market_order',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_UserCertification'),
					href: '/user_certification',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_User_Referral'),
					href: '/UserReferral',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_Info_Referral'),
					href: '/InfoReferral',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_Withdrawal'),
					href: '/Withdrawal',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_Challenge_session'),
					href: '/challenge_session',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_Challenge_contents'),
					href: '/challenge_contents',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name:t('route.C_Notion_Terms'),
					href:'/notion_terms',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name:t('route.C_Notion_Notice'),
					href:'/notion_notice',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name:t('route.C_Notification'),
					href:'/notification',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_Step_Up'),
					href: '/step_up',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
			],
		},
		{
			name: t('route.P_TransmissionDetails'),
			icon: { text: 'Person', class: 'material-symbols-outlined' },
			children: [
				{
					name: t('route.C_TransitionHistory'),
					href: '/transition_history',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
				{
					name: t('route.C_SwapTransactions'),
					href: '/swap_transactions',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
			],
		},
		{
			name: t('route.P_Config'),
			icon: { text: 'Person', class: 'material-symbols-outlined' },
			children: [
				// {
				//   name: t("route.C_AccountInfo"),
				//   href: "/account_info",
				//   icon: { text: "Circle", class: "material-symbols-outlined" },
				// },
				{
					name: t('route.C_Password'),
					href: '/password',
					icon: { text: 'Circle', class: 'material-symbols-outlined' },
				},
			],
		},
	];
});

const sidebarStatus = computed(() => {
	return store.state.app.sidebarStatus;
});

const adminName = computed(() => {
	return store.state.app.info.name;
});

return (_ctx: any,_cache: any) => {
  const _component_VueAwesomeSideBar = _resolveComponent("VueAwesomeSideBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass('title ' + (sidebarStatus.value ? 'small' : ''))
    }, _toDisplayString(_unref(t)('info.title')), 3),
    _createElementVNode("div", {
      class: _normalizeClass('user-panel ' + (sidebarStatus.value ? 'small' : '')),
      style: _normalizeStyle(sidebarStatus.value ? 'display:none' : '')
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "pull-left image" }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "img-circle"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(adminName.value), 1)
      ])
    ], 6),
    _createVNode(_component_VueAwesomeSideBar, {
      miniMenu: sidebarStatus.value,
      "onUpdate:miniMenu": _cache[0] || (_cache[0] = ($event: any) => ((sidebarStatus).value = $event)),
      menu: menuList.value,
      width: "300px",
      position: "relati",
      dark: true,
      BottomMiniMenuBtn: false,
      paddingTop: "0px",
      height: "100%",
      "vue-router-enabel": ""
    }, null, 8, ["miniMenu", "menu"])
  ], 64))
}
}

})